import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import LoadingSpinner from '../../components/LoadingSpinner';
import { useAuth } from '../../hooks/useAuth';
import * as pkgApi from '../../api/packages.api';
import * as quizApi from '../../api/quiz.api';
import { errorMessage } from '../../api/client';
import { PatientCardView } from '../packages/Packages';

// Patient dashboard: stripped to the treatment-plan catalogue. The user picks a
// plan and is funnelled into the eligibility quiz before they can check out.
function UserDashboard() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [quiz, setQuiz] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      pkgApi.listPackages({ active: true }),
      quizApi.myLatestQuiz().catch(() => null),
    ])
      .then(([pkgs, q]) => {
        if (cancelled) return;
        setItems((pkgs || []).filter((p) => p.isActive));
        setQuiz(q || null);
      })
      .catch((e) => { if (!cancelled) setErr(errorMessage(e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const first = user?.name?.split(' ')[0];

  return (
    <>
      <PageHeader
        title={`Hello ${first || 'there'}`}
        subtitle="Pick a treatment plan — we'll run a quick eligibility quiz before you book."
      />

      {quiz?.eligibilityStatus === 'NOT_ELIGIBLE' && (
        <div className="notice warning" style={{ marginBottom: 'var(--s-4)' }}>
          Based on your last quiz you aren't eligible for GLP-1 treatment right now.
          Please consult a doctor first. <Link to="/quiz">Retake quiz</Link>.
        </div>
      )}
      {quiz?.eligibilityStatus === 'CONDITIONAL' && (
        <div className="notice" style={{ marginBottom: 'var(--s-4)' }}>
          You may be eligible — your clinic doctor will confirm before your first injection.
        </div>
      )}

      {err && <div className="notice warning" style={{ marginBottom: 'var(--s-4)' }}>{err}</div>}

      {loading ? <LoadingSpinner /> : <PatientCardView items={items} quiz={quiz} />}
    </>
  );
}

export default UserDashboard;
